import { isMobile as isMobileDevice } from "react-device-detect";

export class AVAuth {
  static avToken: {
    authToken: string;
    expires: Date;
    isComplete: boolean;
    refreshToken: string;
    staySignedIn: boolean;
  } | null = null;

  static waitRedir: boolean = false;
  static waitRefresh: boolean = false;
  static debug: boolean = false;
  static isTest: boolean = true;

  // Get the base URL for API calls based on environment
  public static getBaseURL(): string {
    // Remove when we reset env
    if (this.debug) return "https://localhost:7245/";

    if (window.location.hostname == "dev.actavivo.com")
      return "https://authdev.actavivo.com/";
    if (window.location.hostname == "qa.actavivo.com")
      return "https://authqa.actavivo.com/";
    if (this.isTest && window.location.hostname == "localhost")
      return "https://authqa.actavivo.com/";
    if (!this.isTest && window.location.hostname == "localhost")
      return "https://authdev.actavivo.com/";

    return "https://auth.actavivo.com/";
  }

  // Handle redirection from the identity provider after login, extract AVTok and exchange for authToken
  public static async handleRedir(): Promise<boolean> {
    if (AVAuth.waitRedir) return false;

    const params = new URLSearchParams(window.location.search);

    var redirTok = params.get("AVTok");

    function openAppOrFallback(redirTok: string) {
      const appLink = "actavivo://actavivo.com/AVTok=" + redirTok;
      const fallbackLink = "https://qa.actavivo.com/?AVTok=" + redirTok; // or App Store link

      // Create an invisible iframe for iOS to avoid error popup
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = appLink;
      document.body.appendChild(iframe);

      // After a short timeout, redirect to fallback if app didn�t open
      //setTimeout( () =>
      //{
      //    window.location.href = fallbackLink;
      //}, 2000 );
    }

    if (redirTok) {
      //if ( redirTok && isMobileDevice )
      //{
      //    openAppOrFallback( redirTok );
      //}
      if (isMobileDevice) {
        /*//try {*/
        // setTimeout(() => {
        window.location.href = "actavivo://actavivo.com/AVTok=" + redirTok;
        // }, 5000); // 5s delay
        //} catch (error) {
        //  console.error("Deep link navigation failed:", error);
        //}
      }

      AVAuth.waitRedir = true;
      params.delete("AVTok");

      let searchString =
        params.toString().length > 0 ? "?" + params.toString() : "";
      let newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        searchString +
        window.location.hash;
      window.history.replaceState(null, "", newUrl);

      // Get AuthToken
      console.log("redirTok@@@@@@@@@@", redirTok);
      var header = {};
      await fetch(
        AVAuth.getBaseURL() + "api/Auth/AuthToken?token=" + redirTok,
        {
          method: "GET",
          headers: header,
        },
      ).then(async function (response) {
        if (response.redirected) {
          console.log("resp: ", "redir");
        } else if (response.status === 401) {
          // Bad token
          // if (AVAuth.avToken)
          // await AVAuth.getToken();
        } else if (response.ok) {
          AVAuth.avToken = await response.json();
          if (AVAuth.avToken?.staySignedIn) {
            localStorage.setItem("AVAuth", JSON.stringify(AVAuth.avToken));
          }
          AVAuth.waitRedir = false;
          return true;
        }
      });
    }

    AVAuth.waitRedir = false;
    return false;
  }

  public static async init() {
    await AVAuth.getToken();
  }

  // Check whether user is logged in based on local storage token
  public static isLoggedIn(): boolean {
    const localStorageData = localStorage.getItem("AVAuth");
    console.log("localStorageData@@@@@@", localStorageData);

    if (!localStorageData) {
      if (AVAuth.avToken) {
        console.log("AVAuth.avToken@@@@@", AVAuth.avToken);
        return true;
      }

      return false;
    }

    try {
      const avAuth = JSON.parse(localStorageData);
      const authToken = avAuth?.authToken;
      console.log("authToken@@@@@@@@", authToken);

      return !!authToken;
    } catch (e) {
      console.error("Error parsing AVAuth from localStorage:", e);
      return false;
    }
  }

  // Check whether token is a fully authenticated app token
  public static isAppAuth(): boolean {
    if (this.avToken && this.avToken.isComplete === true) {
      return true;
    }

    return false;
  }

  // Logout user and redirect to logout page with returnUrl
  public static async logout() {
    // Clear authentication data locally
    AVAuth.avToken = null;
    localStorage.removeItem("persist:root");
    localStorage.removeItem("AVAuth");
    // Build return URL (where the user should go after full sign-out)
    const baseUrl = window.location.origin;
    const logoutUrl = `${this.getBaseURL()}identity/account/logout?returnUrl=${encodeURIComponent(baseUrl)}`;

    // Redirect to server logout
    window.location.href = baseUrl;
  }

  // Initiate login flow by redirecting to the identity provider
  public static async signIn() {
    await AVAuth.handleRedir();

    if (!AVAuth.waitRedir) {
      localStorage.removeItem("AVAuth");
      AVAuth.avToken = null;
      window.location.href =
        this.getBaseURL() +
        "identity/account/login?returnUrl=" +
        window.location.href;
    }
  }

  // Refresh authentication token
  public static async refreshToken(force: boolean = false) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    //Only do 1 at a time
    if (AVAuth.waitRefresh) {
      var exit = 1;
      while (AVAuth.waitRefresh) {
        await delay(100);
        exit++;
        //Dont spin forever
        if (exit > 20) break;
      }
      return;
    }

    AVAuth.waitRefresh = true;
    var header = {};
    header["Accept"] = "application/json";
    header["Content-Type"] = "application/json";
    localStorage.removeItem("AVAuth");
    await fetch(AVAuth.getBaseURL() + "api/Auth/RefreshToken", {
      method: "Post",
      body: JSON.stringify(this.avToken),
      headers: header,
    }).then(async function (response) {
      if (response.redirected) {
      } else if (response.status === 403) {
        AVAuth.signIn();
      } else if (response.status === 401) {
        AVAuth.signIn();
      } else if (response.ok) {
        AVAuth.avToken = await response.json();
        if (AVAuth.avToken?.staySignedIn) {
          localStorage.setItem("AVAuth", JSON.stringify(AVAuth.avToken));
        }
      }
    });

    AVAuth.waitRefresh = false;
  }

  // Retrieve the current authentication token, refresh if needed
  public static async getToken() {
    await AVAuth.handleRedir();

    if (this.avToken != null) {
      if (
        this.avToken.isComplete !== true ||
        new Date(this.avToken.expires) < new Date()
      ) {
        await AVAuth.refreshToken();
      }
      return AVAuth.avToken?.authToken;
    } else {
      var sTok = localStorage.getItem("AVAuth");
      if (sTok != null) {
        AVAuth.avToken = JSON.parse(sTok);
        if (
          AVAuth.avToken &&
          (AVAuth.avToken.isComplete !== true ||
            new Date(AVAuth.avToken.expires) < new Date())
        )
          await AVAuth.refreshToken();
        if (!AVAuth.avToken) AVAuth.signIn();
        return AVAuth.avToken?.authToken;
      }
    }

    AVAuth.signIn();
  }

  public static currentUser() {
    if (AVAuth.avToken) return { username: "Temp Name TODO" };

    return null;
  }

  // Validate whether the token meets the "isAppAuth" requirement
  public static isValidClaim(): boolean {
    return AVAuth.isAppAuth();
  }
}
